import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What's your code for?",
  "description": "Perfect code that doesn't solve the problem is useless. Perfect metrics that don't serve the user are a distraction.",
  "published": "2020-11-06T00:00:00.000Z",
  "categories": "Thoughts, Opinions",
  "content_upgrade": "SeniorMindset",
  "hero": "./img/screenshot-1604679297656.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Solving problems. Business or otherwise.`}</p>
    <p>{`Perfect code that doesn't solve the problem is useless. Perfect metrics that don't serve the user are a distraction.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`this is how developers solve problems `}<a parentName="p" {...{
          "href": "https://t.co/tcNpRVEk2A"
        }}>{`pic.twitter.com/tcNpRVEk2A`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1324465764422877184"
      }}>{`November 5, 2020`}</a></blockquote>
    <p>{`Or as `}<a parentName="p" {...{
        "href": "https://wiki.c2.com/?MakeItWorkMakeItSmallMakeItFast"
      }}>{`Ward Cunningham said`}</a>{` on the world's first ever wiki:`}</p>
    <ol>
      <li parentName="ol">{`Make it work`}</li>
      <li parentName="ol">{`Make it right`}</li>
      <li parentName="ol">{`Make it fast`}</li>
    </ol>
    <p>{`In that order. A fast program that isn't right, useless. A perfect program that doesn't work, useless. A fast program that doesn't work ... impressive. But useless.`}</p>
    <p>{`Happy weekend ❤️`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: this approach helps you `}<a parentName="p" {...{
        "href": "https://twitter.com/swyx/status/1263226767021469696"
      }}>{`shift left`}</a>{` and catch bugs, bad specs, and misunderstandings early. Before they're expensive to fix`}</p>
    <p>{`PPS: it's okay to write perfect code without a goal in mind for fun; to me it gets boring fast`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      